import { render, staticRenderFns } from "./CartItem_Ap.vue?vue&type=template&id=64c06a96&scoped=true"
import script from "./CartItem_Ap.vue?vue&type=script&lang=js"
export * from "./CartItem_Ap.vue?vue&type=script&lang=js"
import style0 from "./CartItem_Ap.vue?vue&type=style&index=0&id=64c06a96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c06a96",
  null
  
)

export default component.exports